import React from 'react';
import { Building2 } from 'lucide-react';
import { CostCenterManager } from '../registers/CostCenter';
import { CostCenterSummary } from './CostCenterSummary';

export function SimpleCostCenterPage() {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold tracking-tight flex items-center gap-2">
            <Building2 className="h-8 w-8 text-primary" />
            Centros de Custo
          </h1>
          <p className="text-muted-foreground">
            Gerencie a estrutura organizacional de centros de custo
          </p>
        </div>
      </div>

      <CostCenterSummary />

      <CostCenterManager />
    </div>
  );
}